import { styled } from '@/stitches.config';
import { Box, Button, SectionTitle } from '@base-app';

export const TeamsListContainerStyled = styled(Box, {
  maxWidth: '$layoutMaxWidth',
  padding: '$layoutPadding',
  margin: 'auto',
});

export const TeamsListHeaderStyled = styled(Box, {
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  py: '$4',
});

export const TeamsListSectionTitleStyled = styled(SectionTitle, {
  textAlign: 'left',
  padding: '$0 $4',
  '@sm': {
    padding: '$0 $8',
  },
});

export const AddTeamMemberButtonStyled = styled(Button, {
  '@xs': {
    position: 'fixed',
    left: '0',
    bottom: '0',
    width: '100%',
  },
});

export const PaginationContainerStyled = styled(Box, {
  alignItems: 'center',
  display: 'flex',
  flexDirection: 'column',
  mb: '$12',
  mt: '$8',
  justifyContent: 'center',

  '@sm': {
    flexDirection: 'row',
    justifyContent: 'space-between',
  },
});
